module.exports = __webpack_public_path__ + "img/pr-4.95616c5a.png";